import { ChangeDetectorRef, Component, OnDestroy } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { Subscription } from 'rxjs';
import { AccountContextService } from './authentication/services/account-context.service';
import { MatDialog } from '@angular/material/dialog';
import { MatLegacyDialog } from '@angular/material/legacy-dialog';

declare var gtag;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})

export class AppComponent implements OnDestroy {
  title = 'connect-website';
  languageKey = "lang";
  reloadRouterOutlet = true;
  private accountChangedSubscription: Subscription;

  constructor(
    public translate: TranslateService,
    private router: Router,
    private accountContext: AccountContextService,
    private changeDetectorRef: ChangeDetectorRef,
    private dialog: MatDialog,
    private legacyDialog: MatLegacyDialog) {
    translate.addLangs(['en', 'pt', 'es']);
    const storedLanguage = localStorage.getItem(this.languageKey);

    if (storedLanguage) {
      translate.use(storedLanguage.match(/en|pt|es/) ? storedLanguage : 'en');
    }
    else {
      const language = translate.getBrowserLang();
      localStorage.setItem(this.languageKey, language);
      translate.setDefaultLang(language);
    }

    const navEndEvent$ = router.events.pipe(
      filter(e => e instanceof NavigationEnd)
    );
    navEndEvent$.subscribe((e: NavigationEnd) => {
      gtag('config', 'UA-1283795-54', { 'page_path': e.urlAfterRedirects });
    });

    this.accountChangedSubscription = this.accountContext.accountChanged$
      .subscribe(() => this.reloadCurrentRoute());
  }

  ngOnDestroy(): void {
    this.accountChangedSubscription?.unsubscribe();
  }

  private reloadCurrentRoute(): void {
    this.reloadRouterOutlet = false;
    this.changeDetectorRef.detectChanges();
    this.dialog.closeAll();
    this.legacyDialog.closeAll();

    setTimeout(() => {
      this.reloadRouterOutlet = true;
      this.changeDetectorRef.detectChanges();
    });
  }
}
